






import { defineComponent, reactive, toRefs, onMounted } from '@vue/composition-api';
import AlertArea from "../../components/AlertArea.vue";
import http from "../../plugins/http";

export interface Data {
  errors: string[]
}

export default defineComponent({
  components: {
    "alert-area": AlertArea,
  },
  setup(prop, context){

    /******************************
     * data
     ******************************/

    const state = reactive<Data>({
      errors: new Array<string>(),
    });

    /******************************
     * mounted
     ******************************/
    
    onMounted(async () => {

      context.root.$store.dispatch("showOverlay");
      context.root.$store.commit("setIsParent", (context.root.$route.query.is_parent as string).toLowerCase() === "true");
      document.cookie = `smarky_is_parent=${context.root.$store.state.is_parent ? "1" : "0"}`;
      
      await http.post(`/api/google_sessions/student_login`, {token: context.root.$route.query.t}).then(response => {
        
        var user = response.data.user;

        // トークン設定
        var token = user.access_token
        document.cookie = `access_token=${token}`;
        document.cookie = 'smarky_user_id=' + user.id;
        context.root.$store.commit("setCurrentUser", user);
        context.root.$store.commit("setStudentCode", response.data.student_code);
        context.root.$store.commit("setStudentName", response.data.student_name);
        

        if(context.root.$store.getters.isOptionLessonActive){
          context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/lesson_class_list`).catch(err => {});
        }else{
          context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/sheet_list`).catch(err => {});
        }
        context.root.$store.commit("setIsHeaderDisp", true);
      })
      .catch(error=>{
        // エラーの場合はログイン画面に戻る
        context.root.$router.push(`/${context.root.$store.state.school_url_prefix}/student_site/sign_in?error_kind=${error.response.data.error_kind}`).catch(err => {});
      });
      context.root.$store.dispatch("hideOverlay");
    });

    return {
      ...toRefs(state),
    }
  }
})
